<template>
  <div v-bind:id="def.id">
    <form class="needs-validation">
      <div class="card">
        <div class="card-body">
          <div class="float-end funcArea">
            <a href="#" class="btn btn-sm btn-outline-secondary" style="margin-right:4px"
              v-on:click="cancelClick">Cancel</a>
            <a href="#" class="btn btn-sm btn-outline-primary" style="margin-right:4px" v-on:click="okclick('ok')"><i
                class="fa fa-check"></i>
              {{ this.$t('lang.toolbar.OK') }}</a>
            <span id="btnMore" type="button" class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i> </span>
            <div class="dropdown-menu" aria-labelledby="btnMore">
            </div>
          </div>
          <div class="form-group row">
            <div class="col-auto form-check form-check-inline" v-for="item in showOptCheckItems" :key="item.id">
              <input class="form-check-input" type="checkbox" :name="'itemTypeCheck' + item.id"
                :disabled="item.val != '' && item.val != null" :id="'inlineCheck2' + item.id" v-model="item.show">
              <label class="form-check-label" :for="'inlineCheck2' + item.id">{{ item.title }}</label>
            </div>
            <div class="col-auto form-check form-check-inline" v-if="def.tp.countGallary > 0">
              <label class="form-check-label btn-link click-cursor" @click="drawer = true">{{ $t('lang.dict.gallary')
                }}</label>
            </div>
          </div>
          <div class="form-group row" v-for="item in def.tp.items" :key="item.id">
            <!-- <label class="d-none d-sm-block col-2 col-form-label col-form-label-sm text-right">{{ item.title }}</label> -->
            <template v-if="item.groups">
              <GeneralInputItem :item="cell" v-for=" cell  in  item.groups " :key="cell.id" />
            </template>
            <template v-else>
              <GeneralInputItem :item="item" />
            </template>
          </div>
          <input type="hidden" id="dictwhere">
          <span class="btn btn-sm btn-outline-primary my-1" data-bs-toggle="modal" data-bs-target="#myModalAlbum"
            :data-bs-fileList="metaFileList">
            {{ $t('lang.dict.showGallery') }}
          </span>
          <div class="d-flex row">
            <div class="col-md-2 col-sm-6" v-for="file in metaFileList" :key="file">
              <el-image :src="file" fit="cover"></el-image>
            </div>
          </div>
          <div v-for="area  in  def.tp.areas " :key="area.name">
            <label class="d-none d-sm-block col-2 col-form-label col-form-label-sm text-right">{{ area.subname
              }}</label>
            <div class="form-group row" v-for=" group  in  area.groups " :key="group.name">
              <!-- <label class="d-none d-sm-block col-2 col-form-label col-form-label-sm text-right">{{ group.name }}</label> -->
              <GeneralInputItem :item="item" v-for=" item  in  group.items " :key="item.id" />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="modal fade" id="myModalAlbum" tabindex="-1" aria-labelledby="exampleModalScrollableTitle"
      aria-hidden="true">
      <div class="modal-dialog  modal-xl  modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalScrollableTitle">{{ this.$t('lang.dict.gallary') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-4">
              <div class="col p-2" v-for="item in imgurlList" :key="item.imgurl">
                <figure class="figure bg-success-subtle p-2 rounded">
                  <figcaption class="figure-caption text-end">
                    <input class="form-check-input" type="checkbox" v-model="item.selected" :id="item.imgurl">
                  </figcaption>
                  <label class="form-check-label" :for="item.imgurl">
                    <img :src="item.imgurl" class="figure-img img-thumbnail rounded" alt="...">
                  </label>
                </figure>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <el-drawer :title="$t('lang.dict.gallary')" :visible.sync="drawer" direction="btt" size="45%"
      :before-close="handleClose">
      <div class="container-fluid">
        <el-upload ref="imgUploader" action="#" accept=".jpg,.png" list-type="picture-card" :multiple="true"
          :file-list="fileList" :limit="def.tp.countGallary" :on-change="handlePictureSelected" :auto-upload="false">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from "moment"
import GeneralInputItem from "./GeneralInputItem.vue";
import $ from "jquery";
import sx from "../utils/core.js";

export default {
  components: {
    GeneralInputItem
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      drawer: false,
      paramAlbum: {},
      fileList: [],
      imgurlList: [],
      unlinkList: [],
      metaFileList: []
    };
  },
  computed: {
    showOptCheckItems: function () {
      if (this.def.tp.items) {
        return this.def.tp.items.filter(function (item) {
          return item.show == true || item.show == false
        })
      } else {
        return []
      }
    }
  },
  watch: {
    'def.meta': function (newVal) {
      console.log(newVal)
      const that = this
      if (that.def.meta.gallery) {
        that.fileList = [];
        $.each(that.def.meta.gallery, function (idx, url) {
          var baseurl = 'https://cloud.salesmini.cn'
          that.fileList.push({
            url: baseurl + url
          })
        });
      }
      if (that.def.meta.fileList) {
        that.metaFileList = that.def.meta.fileList
      }
    }
  },
  props: {
    def: {
      id: String,
      title: String,
      isLarge: true,
      isSmall: true,
      tableid: String,
      meta: {},
      tp: {
        items: [],
        areas: []
      },
      items: []
    }
  },
  mounted() {
    const that = this;

    const myModalAlbum = document.getElementById('myModalAlbum')
    myModalAlbum.addEventListener('show.bs.modal', event => {
      // Button that triggered the modal
      const target = event.relatedTarget
      // Extract info from data-bs-* attributes
      const fileList = target.getAttribute('data-bs-fileList')
      that.paramAlbum = {
        paragraphid: target.getAttribute('data-bs-paragraphid'),
        partid: target.getAttribute('data-bs-partid')
      }
      console.log(fileList)
      that.imgurlList = []
      $.each(that.fileList, function (index, file) {
        if (fileList) {
          if (fileList.indexOf(file.url) > -1) {
            that.imgurlList.push({ imgurl: file.url, selected: true })
          } else {
            that.imgurlList.push({ imgurl: file.url, selected: false })
          }
        } else {
          that.imgurlList.push({ imgurl: file.url, selected: false })
        }
      })
    })

    myModalAlbum.addEventListener('hidden.bs.modal', event => {
      // do something...
      var fileList = []
      $.each(that.imgurlList, function (index, item) {
        if (item.selected) {
          fileList.push(item.imgurl)
        }
      })
      if (sx.isNothingOrEmpty(that.paramAlbum.paragraphid)) {
        that.metaFileList = fileList
        return
      }
      $.each(that.def.tp.areas, function (index, area) {
        console.log(index)
        $.each(area.groups, function (idx, group) {
          console.log(idx)
          $.each(group.items, function (i, item) {
            console.log(item)
            if (item.type === "paragraphs") {
              $.each(item.paragraphs, function (index, paragraph) {
                if (paragraph.id === that.paramAlbum.paragraphid) {
                  if (sx.isNothingOrEmpty(that.paramAlbum.partid)) {
                    paragraph.fileList = fileList
                  } else {
                    $.each(paragraph.parts, function (indexpart, part) {
                      if (part.id === that.paramAlbum.partid) {
                        part.fileList = fileList
                      }
                    })
                  }
                }
              })
            }
          })
        })
      })
    })

    that.autoresize();
    $(window).resize(function () {
      that.autoresize();
    });
  },
  methods: {
    handleClose: function (done) {
      this.$confirm('退出前保存图片吗?')
        .then(_ => {
          done();
          this.okclick('save')
        })
        .catch(_ => {
          done();
        });
    },
    selectedImageChanged: function (item) {
      item.selected = !item.selected
    },
    cancelClick: function () {
      const that = this;
      that.$router.replace({ name: that.def.tp.backurl }).catch(error => {
        console.info(error.message);
      })
    },
    handleRemove(file) {
      console.log(file);
      const that = this;
      if (file.status === "ready") {
        that.fileList.splice(that.fileList.indexOf(file), 1)
      } else {
        that.fileList.splice(that.fileList.indexOf(file), 1)
        var list = file.url.split("/");
        var filename = list[list.length - 1];
        that.unlinkList.push(filename)
        that.def.meta.gallery.splice(that.def.meta.gallery.indexOf(filename), 1)
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    handleBeforeUpload(file) {
      console.log(file);
    },
    handlePictureSelected(file, filelist) {
      const that = this;
      console.log(file);
      console.log(filelist);
      //  文件大小限制
      const isLt5M = file.size / 1024 / 1024 < 12;
      if (!isLt5M) {
        sx.toastError(that.$t('lang.error.notLtnM', { n: 12 }));
        return isLt5M;
      }
      //  文件类型限制
      const name = file.name ? file.name : '';
      const ext = name
        ? name.substr(name.lastIndexOf('.') + 1, name.length)
        : true;
      const isExt = "jpg,png".indexOf(ext) < 0;
      if (isExt) {
        sx.toastError(that.$t('lang.error.notAllowedFmt'));
        return !isExt;
      }

      //  圧縮

      var compressConfig = {
        size: 1024
      }
      new Promise((resolve, reject) => {
        const image = new Image();
        const binData = [];
        binData.push(file.raw);
        image.src = window.URL.createObjectURL(new Blob(binData));
        image.onload = () => {
          const resultFile = that.compress(
            image,
            file,
            compressConfig
          )
          resolve(resultFile);
        }
        image.onerror = (err) => {
          reject(err)
        }
      }).then(function onFulfilled(newfile) {
        file.raw = newfile;
        that.fileList = filelist;
      }).catch(function onRejected(error) {
        console.log(error);
      });
    },
    compress: function (image, file, compressConfig) {
      const that = this;
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      //  resize
      var rate = 1.0;
      if (image.width > compressConfig.size && image.height > compressConfig.size) {
        if (image.width > image.height) {
          rate = compressConfig.size / image.width;
        } else {
          rate = compressConfig.size / image.height;
        }
      }
      var width = (rate * image.width).toFixed(0);
      var height = (rate * image.height).toFixed(0);
      var quatity = 0.92;
      if (rate < 0.4) {
        quatity = 0.5;
      } else if (rate >= 0.4 && rate < 0.7) {
        quatity = 0.7
      }
      canvas.width = width;
      canvas.height = height;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, width, height);
      var dataurl = canvas.toDataURL(
        file.type || 'image/jpeg',
        quatity
      );

      return that.dataURItoFile(dataurl, file);
    },
    dataURItoFile: function (dataurl, file) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var pre = moment().format('x');
      var newfile = new File([u8arr], pre + '_' + file.name, {
        type: mime
      });
      newfile.uid = file.uid
      return newfile;
    },
    itemToData(item, dat) {
      const that = this
      var mymodal = $("#" + that.def.id);
      if (item.type === 'hidden') {
        dat[item.id] = mymodal.find(".card-body #" + item.id).val()
      } else if (item.type === 'datepicker') {
        dat[item.id] = mymodal.find(".card-body #" + item.id).val()
      } else if (item.type === 'checkbox') {
        if ($("#" + item.id).is(':checked')) {
          dat[item.id] = "1"
        } else {
          dat[item.id] = "0"
        }
      } else if (item.type === 'tagsinput') {
        dat[item.id] = item.tag
      } else if (item.type === 'label') {
        // 何もしない
      } else {
        dat[item.id] = item.val
      }
    },
    okclick: function (btn) {
      const that = this;
      var mymodal = $("#" + that.def.id);
      if (btn === 'ok') {
        //  validate
        var forms = mymodal.find(".needs-validation");
        var validation = false;
        Array.prototype.filter.call(forms, function (form) {
          if (form.checkValidity() == false) {
            form.classList.add("was-validated");
            validation = true;
          }
        });
        if (validation) {
          return;
        }
      }

      //  save meta
      var meta = {}
      meta.fileList = that.metaFileList
      $.each(that.def.tp.areas, function (index, area) {
        console.log(index)
        $.each(area.groups, function (idx, group) {
          console.log(idx)
          $.each(group.items, function (i, item) {
            console.log(i)
            if (item.type === 'datepicker') {
              meta[item.id] = mymodal.find(".card-body #" + item.id).val()
            } else if (item.type === 'checkbox') {
              if ($("#" + item.id).is(':checked')) {
                meta[item.id] = "1"
              } else {
                meta[item.id] = "0"
              }
            } else if (item.type === 'tagsinput') {
              meta[item.id] = item.tag
            } else if (item.type === 'paragraphs') {
              var plist = [];
              $.each(item.paragraphs, function (index, paragraph) {
                paragraph.additional = "0"
                //  remove files
                if (paragraph.unlinkList) {
                  that.unlinkList = that.unlinkList.concat(paragraph.unlinkList)
                }

                //  parts
                $.each(paragraph.parts, function (indexpart, part) {
                  if (part.title) {
                    part.style = {
                      reservedWords: [part.title]
                    }
                  }
                  //  remove files
                  if (part.unlinkList) {
                    that.unlinkList = that.unlinkList.concat(part.unlinkList)
                  }
                });
              });
              Promise.all(plist).then(function (values) {
                console.log(values);
                meta[item.id] = {
                  seq: item.seq,
                  paragraphs: item.paragraphs
                }
              })
            } else {
              meta[item.id] = item.val
            }
          });
        });
      });

      //  save items
      var items = {}
      $.each(that.def.tp.items, function (index, item) {
        if (item.groups) {
          $.each(item.groups, function (cindex, cellitem) {
            if (sx.isNothingOrEmpty(cellitem.id)) {
              return true; //  continue
            }
            console.log(cindex)
            that.itemToData(cellitem, items)
          });
        } else {
          if (sx.isNothingOrEmpty(item.id)) {
            return true; //  continue
          }
          that.itemToData(item, items)
        }
      });

      const mywaitingmodal = sx.showWaiting();

      // upload
      sx.upload(
        that.fileList,
        function (result) {
          console.log("upload3:", result)
          if (result && result.status === "ok") {
            // save
            if (result.message !== "none") {
              if (that.def.meta.gallery) {
                meta.gallery = that.def.meta.gallery.concat(result.data.pathlist);
              } else {
                meta.gallery = result.data.pathlist;
              }
            }
            items.meta = JSON.stringify(meta)
          }

          if (btn !== 'ok') {
            sx.hideWaiting(mywaitingmodal);
            return
          }

          if (result && result.status !== "ok") {
            sx.toastError("0001 request failed:" + result.message);
          } else {
            //  submit
            if (that.def.mode === "update") {
              var params = {
                items: JSON.stringify(items),
                keys: JSON.stringify({
                  id: localStorage.getItem('postinfo.id'),
                  bucketid: '13'
                }),
                token: localStorage.getItem("token")
              };
              if (that.def.tp.indexedkeys) {
                params.indexedkeys = JSON.stringify(that.def.tp.indexedkeys)
              }
              sx.request(
                that.def.updateurl,
                params,
                function (result) {
                  if (result.status === "ok") {
                    setTimeout(function () {
                      sx.toastSuccess(that.$t('lang.info.succeedUpdate'));
                    }, 200);
                    that.$store.state.editdef.updated = true
                    that.cancelClick();
                  } else {
                    sx.toastError("1001 request failed:" + result.message);
                  }
                  sx.hideWaiting(mywaitingmodal);
                },
                function (result) {
                  console.log(result)
                  sx.login(
                    that.def.updateurl,
                    params,
                    function (result) {
                      if (result.status === "ok") {
                        setTimeout(function () {
                          sx.toastSuccess(that.$t('lang.info.succeedUpdate'));
                        }, 200);
                        that.$store.state.editdef.updated = true
                        that.cancelClick();
                      } else {
                        sx.toastError("1002 request failed:" + result.message);
                      }
                      sx.hideWaiting(mywaitingmodal);
                    }
                  )
                }
              );
            } else {
              items.bucketid = '13'
              items.kbn = "00"; //  post
              var paramsIns = {
                items: JSON.stringify(items),
                token: localStorage.getItem("token")
              }
              sx.request(
                that.def.inserturl,
                paramsIns,
                function (result) {
                  if (result.status === "ok") {
                    setTimeout(function () {
                      sx.toastSuccess(that.$t('lang.info.succeedInsert'));
                    }, 200);
                    that.cancelClick();
                  } else {
                    sx.toastError("2001 request failed:" + result.message);
                  }
                  sx.hideWaiting(mywaitingmodal);
                },
                function (result) {
                  console.log(result)
                  sx.login(
                    that.def.inserturl,
                    paramsIns,
                    function (result) {
                      if (result.status === "ok") {
                        setTimeout(function () {
                          sx.toastSuccess(that.$t('lang.info.succeedInsert'));
                        }, 200);
                        that.cancelClick();
                      } else {
                        sx.toastError("2002 request failed:" + result.message);
                      }
                      sx.hideWaiting(mywaitingmodal);
                    }
                  )
                }
              );
            }
          }

          sx.hideWaiting(mywaitingmodal);
        },
        function (result) {
          console.log("3001 request failed:" + result.message);
          //  sx.toastError("3 request failed:" + result.message);
        }
      );
    },
    unlink(filenamelist) {
      const that = this
      $.each(filenamelist, function (index, filename) {
        var params = {
          filename: filename,
          token: localStorage.getItem("token")
        };
        var url = that.$store.state.baseurl + '/app/cmshelper/unlinkFile'
        sx.request(
          url,
          params,
          function (result) {
            if (result.status === "ok") {
              sx.toastSuccess(that.$t('lang.info.succeedDelete'));
            } else {
              sx.toastError("Failed:" + result.message);
            }
          },
          function (result) {
            console.log(result)
          }
        )
      })
    },
    autoresize() {
      var h = $(window).height();
      var h2 = h - 300;
      $(".metalist").css("height", h2);
    }
  }
};
</script>
<style scoped>
.funcArea {
  margin-bottom: 6px
}

.card {
  margin-bottom: 4px;
}

.metalist {
  overflow-y: scroll;
  height: 100%;
}

.col-sm-12 {
  padding-left: 5px;
  padding-right: 5px;
}

.card-body {
  padding: 1.25rem
}

.item-title {
  color: lightgray;
  padding-left: 10px;
}

.click-cursor {
  cursor: pointer;
}

.el-message-box {
  width: 280px
}
</style>
